module.exports = __webpack_public_path__ + "assets/img/bg-line-driver-192a7948.png";